import { visit as turbolinksVisit } from 'turbolinks';

export function visit(location: string) {
  return turbolinksVisit(location);
}
